import { Box } from "@mui/material";
import React from "react";

import { Typography } from "new-components/typography/Typography";
import { colorClassNameMap, stringClassNameMap } from "utils/disagreementsUtils";

export interface ResponseLabelProps {
  type: string;
  className: string;
  currentClassNameAnswer: string;
}

export function ResponseLabel(props: ResponseLabelProps) {
  const { type, className, currentClassNameAnswer } = props;

  const getLabelText = () => {
    const isRetained = className === stringClassNameMap[currentClassNameAnswer];
    if (type === 'Labeler') {
      return isRetained ? 'Retained' : 'Changed to';
    }
    return isRetained ? 'Confirmed' : 'Override';
  };

  return (
    <Box className="flex justify-center items-center gap-2">
      <Typography variant="detail" fontWeight="semibold" textTransform="uppercase" className="text-gray-500">
        {`${type} ${getLabelText()}:`}
      </Typography>
      <Box className="px-3 py-1 rounded-3xl" bgcolor={(className && colorClassNameMap[className]) || "#535353"}>
        <Typography variant="detail" fontWeight="semibold" textTransform="uppercase" className="text-white">
          {className || "Unclear"}
        </Typography>
      </Box>
    </Box>
  );
}
